module.exports = __webpack_public_path__ + "img/yz_game_commentmonthVip01.f2843057.png";